<template>
  <div
    :key="'reputation' + fId + $store.state.counter"
    v-if="
      $store.state.app.basics.modules &&
      $store.state.app.basics.modules.indexOf('reputation') > -1 &&
      fId
    "
    class="flex column"
  >
      <div>
        <span class="flex center align-center flexy">
          <span
            class="flex align-center center"
            @click="($store.state.user[$store.state.auth.uid] && !$store.state.user[$store.state.auth.uid].userreps) || ($store.state.user[$store.state.auth.uid].userreps && !$store.state.user[$store.state.auth.uid].userreps[fId]) ?
              $store
                .dispatch('create', {
                  type: 'reputation',
                  id: fId,
                  data: { quality: 5 },
                  fType,
                })
                .then((r) => {
                  $store.dispatch('query', {
                    type: 'reputation',
                    id: r.rId,
                  });
                }) : $store.dispatch('delete', {type: 'reputation', rid: $store.state.user[$store.state.auth.uid].userreps[fId], id: fId})
            "
          >
            <i :class="$store.state.reputation[fId] && $store.state.reputation[fId].meta && $store.state.reputation[fId].meta.count > 0 ? 'warn-text' : ''" class="far fa-heart fa-2x m4"></i>
            <span
            :class="$store.state.user[$store.state.auth.uid] && $store.state.user[$store.state.auth.uid].userreps && $store.state.user[$store.state.auth.uid].userreps[fId] && 'white'"
            v-if="
              $store.state.reputation[fId] && $store.state.reputation[fId].meta && $store.state.reputation[fId].meta.count > 0
            "
            >{{ $store.state.reputation[fId].meta.count }}</span
          >
          </span>
          
        </span>
        <!-- 
        <span class="flex center flexy">
          <span
            class="flex center around r8"
            @click="
              $set(
                $store.state.show.tokens,
                fId,
                !$store.state.show.tokens[fId]
              )
            "
          >
            <i class="fas fa-coins r4"></i>
            <b v-if="$store.state.show.tokens[fId]">Send Tip</b></span
          >
          <span
            class="flex center r8"
            @click="
              $set(
                $store.state.show.feedback,
                fId,
                !$store.state.show.feedback[fId]
              )
            "
            >Review</span
          <span class="flex center r8" @click="showShare = !showShare">
            <i class="fas fa-share r4"></i>
          </span>
        </span>
          > -->
      </div>
    <div
      v-if="$store.state.show.tokens[fId] && $store.state.reputation[fId]"
      class="token sub-container flex"
    >
      <img src="/img/icons/favicon-96x96.png" alt style="height: 50px" />
      <input type="number" v-model.number="mbAmount" />
    </div>
    <div
      v-if="$store.state.show.feedback[fId] && $store.state.reputation[fId]"
      style="
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        width: -webkit-fill-available;
      "
      class="flex column p4 between"
    >
      <div style="min-height: 148px" class="flex column xs-font">
        <textarea
          autofocus
          class="fill stretch"
          type="text"
          v-model="feedback.content"
          placeholder="Review"
        ></textarea>
        <div class="flex column center" style="width: 100%">
          <b class="p4">Rating</b>
          <div class="flex around b8" style="width: 100%">
            <span :key="xKey" v-for="(x, xKey) in 5">
              <i
                :class="`fa${feedback.quality > xKey ? 's' : 'r'} fa-star`"
                @click="feedback.quality = x"
              ></i>
            </span>
          </div>
        </div>
        <button
          :disabled="feedback.content.length < 2"
          class="indicate b8 p8"
          type="button"
          @click="
            $store.dispatch('create', {
              type: 'reputation',
              id: fId || $route.params.id || $route.name,
              data: feedback,
              fType,
            });
            feedback = { content: '', quality: 5 };
          "
        >
          Submit Review
        </button>
      </div>

      <div
        :key="repKey"
        v-for="(rep, repKey) in $store.state.reputation[fId].data"
      >
        <div
          v-if="
            $store.state.reputation[fId] &&
            $store.state.reputation[fId].data &&
            (rep.feedback.skills || rep.feedback.content)
          "
          class="flex column b8 between xs-font sub-container"
        >
          <div class="flex wrap between align-center b8">
            <user :userid="rep.user"></user>
            <div class="flex center">
              <i
                :key="xKey"
                v-for="(x, xKey) in rep.feedback.quality"
                :class="`fa-xs fas fa-star`"
              ></i>
            </div>
          </div>
          <div class="flexy flex column">
            <span class="md-font">{{ rep.feedback.content }}</span>
          </div>
          <reputation
            class="xs-font"
            :key="$store.state.componentKeys.reputation + repKey"
            :fId="repKey"
            fType="reputation"
          ></reputation>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// todo fix when clicking heart in post view of ilist
// Uncaught (in promise) FirebaseError: property path is longer than 1500 bytes.
export default {
  name: "reputation",
  mounted() {
    if (this.$store.state.reps.includes(this.fId)) {
      return;
    } else {
      this.$store.state.reps.push(this.fId);
      !this.$store.state.reputation[this.fId]
        ? this.$store.dispatch("query", { type: "reputation", id: this.fId })
        : null;
    }
  },
  data() {
    return {
      feedback: {
        content: "",
        quality: 5,
      },
      loaded: false,
      mbAmount: 0.5,
      showFull: true,
      showFeedback: false,
      showShare: false,
    };
  },
  methods: {
    closeAllFeedback() {
      this.$set(this.$store.state.show.feedback, this.fId, false);
      this.$set(this.$store.state.show.share, this.fId, false);
    },
  },
  props: {
    fId: { type: String },
    fType: { type: String },
    fSuper: { type: String },
  },
};
</script>